import { Typography, WithStyles, withStyles } from "@material-ui/core";
import { styles } from "../admin/EmptyOrderView.styles";
import React, { useEffect } from "react";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";
import { useDispatch } from "react-redux";
import { useAuthContext } from "../../../auth/AuthProvider";
import * as UserDetailsAction from "../../../stores/user/UserDetailsAction";

export interface IAcceptPrivacyNoticeSuccessViewProps extends WithStyles<typeof styles> {}

const AcceptPrivacyNoticeSuccessViewPure: React.FunctionComponent<IAcceptPrivacyNoticeSuccessViewProps> = ({
    classes
}) => {
    const dispatch = useDispatch();
    const authContext = useAuthContext();
    const userId = authContext?.user?.id;

    useEffect(() => {
        if (userId) {
            dispatch(UserDetailsAction.requestCurrentUser(userId));
        }
    }, [dispatch, userId]);

    return (
        <CenteredContainer>
            <div className={classes.title}>
                <Typography variant="h2">Privacy notice</Typography>
            </div>
            <Typography variant="h3">Success!</Typography>
            <Typography variant="body1">You have accepted the Privacy notice. Now you can access your account.</Typography>
        </CenteredContainer>
    );
};

export const AcceptPrivacyNoticeSuccessView = withStyles(styles)(AcceptPrivacyNoticeSuccessViewPure);
